/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPAssessmentRatingBand } from './rdSAPAssessmentRatingBand';


/**
 * A letter value plus a number. Which are combined.
 */
export interface RatingBandMeasurement { 
    band: RdSAPAssessmentRatingBand;
    /**
     * The rating value associated with this measurement.
     */
    rating: number;
}
export namespace RatingBandMeasurement {
}


